import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutSummary} from '../../domain/workout-summary';
import type {
  WorkoutRepository,
  WorkoutSeriesRange,
} from '../ports/workout.repository';

export class GetCompletedWorkoutSeries
  implements UseCase<[WorkoutSeriesRange], readonly WorkoutSummary[]>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    range: WorkoutSeriesRange,
  ): Promise<Result<readonly WorkoutSummary[], WorkoutError>> {
    return this.repository.getCompletedSeries(range);
  }
}
